import { Badge } from '@/client/components/ui/badge';
import { MapPin, Phone, Shield, Clock } from 'lucide-react';
import type { ClientAccountInfo, ClientEntAuth } from '@shared/types';

interface AccountInfoCardProps {
  accountInfo: ClientAccountInfo | null;
  entAuth: ClientEntAuth | null;
}

export function AccountInfoCard({ accountInfo, entAuth }: AccountInfoCardProps) {
  // Format location string
  const getLocationString = () => {
    if (!accountInfo) return null;
    const parts = [accountInfo.city, accountInfo.state, accountInfo.zip].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : null;
  };

  const location = getLocationString();
  const hasData = location || accountInfo?.phone || entAuth || accountInfo?.demoTTL;

  if (!hasData) {
    return null;
  }

  return (
    <div className="rounded-md border bg-muted/30 px-4 py-3 flex flex-wrap items-center gap-x-6 gap-y-2">
      {location && (
        <div className="flex items-center gap-2 text-sm">
          <MapPin className="h-4 w-4 text-muted-foreground" />
          <span>{location}</span>
        </div>
      )}

      {accountInfo?.phone && (
        <div className="flex items-center gap-2 text-sm">
          <Phone className="h-4 w-4 text-muted-foreground" />
          <span>{accountInfo.phone}</span>
        </div>
      )}

      {entAuth && (
        <div className="flex items-center gap-2 text-sm">
          <Shield className="h-4 w-4 text-muted-foreground" />
          <Badge variant="secondary" className="text-xs">
            {entAuth.authAppName}
          </Badge>
        </div>
      )}

      {accountInfo?.demoTTL && (
        <div className="flex items-center gap-2 text-sm">
          <Clock className="h-4 w-4 text-muted-foreground" />
          <Badge variant="outline" className="text-xs">
            Demo Account
          </Badge>
        </div>
      )}
    </div>
  );
}
